
import React from "react";


import VideoInit from '../../assets/videos/Robots-init.mp4'

function Header() {
    let position = 0;

    var texts = [
        "Bienvenidos a OIP",
        "Automatización y Robótica",
        "Inteligencia Artificial",
        "Total o parcialmente automatizado"
    ];

    var clicks = [
        "",
        "",
        "",
        ""
    ];

    function startSelectors() {
        var parent = document.getElementById("selector-parent");

        for (var i = 0; i < texts.length; i++) {
            var e = document.createElement("div");
            e.className = "selector-round";
            e.setAttribute("position", i);
            e.onclick = (ev) => { changeText(ev.target.getAttribute("position")); position = ev.target.getAttribute("position"); };
            parent.appendChild(e);
        }

        parent.childNodes[0].className += " active";
    }

    function changeText(i) {
        try {
            var selectors = document.getElementById("selector-parent");
            for (var e = 0; e < selectors.childNodes.length; e++) {
                selectors.childNodes[e].className = selectors.childNodes[e].className.split(" ")[0];
            }

            selectors.childNodes[i].className += " active";
        } catch (e) { }

        var parent = document.getElementById("frases");

        //Creating new element
        var newP = document.createElement("p");
        newP.className = "Phrase";
        newP.onclick = () => { };
        newP.style.opacity = 0;
        newP.textContent = texts[i];

        //Animating elements
        parent.childNodes[0].style.opacity = 0;

        parent.appendChild(newP);
        parent.childNodes[1].style.opacity = 0;
        setTimeout(() => parent.childNodes[1].style.opacity = 1, 5)


        //Destroying elements
        setTimeout(() => parent.removeChild(parent.childNodes[0]), 505);
    }

    React.useEffect(() => {
        startSelectors();

        //Auto title selection
        setInterval(() => {
            position++;
            if (position >= texts.length)
                position = 0;

            changeText(position);
        }, 4000);
    });
    

    return (
        <>
            <div className="Page-Flex">

                <video id="v" width="100%" height="100%" autoPlay={true} loop={true} muted={true} style={{
                    position: "absolute",
                    objectFit: "cover"
                }}>
                    <source src={VideoInit} />
                </video>

                <div className="page-header section-home" >

                    

                    <div className="Phrase-Header" style={{ width: "100%", height: "100%", position: "absolute", flexDirection: "column" }} id="frases">
                        <p className="Phrase">
                            Bienvenidos a OIP.
                        </p>
                    </div>

                    <div id="selector-parent"></div>
                </div>
            </div>
        </>
    );
}

export default Header;
